var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_1698)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.5999,
    cy: 14.4,
    rx: 14.4,
    ry: 14.4,
    fill: "url(#paint0_linear_13_1698)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13_1698)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_13_1698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52368 24.2716C11.0774 16.3554 13.3542 12.3973 16.3268 11.069C18.9196 9.91036 21.8804 9.91036 24.4732 11.069C27.4458 12.3973 29.7226 16.3554 34.2763 24.2716C38.83 32.1877 41.1069 36.1458 40.7667 39.3937C40.4701 42.2267 38.9897 44.8003 36.6935 46.4746C34.0611 48.3942 29.5074 48.3942 20.4 48.3942C11.2926 48.3942 6.73889 48.3942 4.10646 46.4746C1.81034 44.8003 0.329917 42.2267 0.0332477 39.3937C-0.306875 36.1458 1.96998 32.1877 6.52368 24.2716Z",
    fill: "#C72752",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1228 10.6125C14.5106 11.3329 13.134 12.746 11.6093 14.912C10.0861 17.0758 8.36932 20.0603 6.10433 23.9978L6.09027 24.0222L6.07623 24.0467C3.81123 27.9841 2.0944 30.9687 0.988946 33.3745C-0.117728 35.7829 -0.648387 37.6854 -0.464033 39.4458C-0.15267 42.4191 1.40113 45.1207 3.81186 46.8786C5.23962 47.9197 7.1475 48.4098 9.77927 48.6521C12.4081 48.8942 15.8418 48.8942 20.3716 48.8942H20.4H20.4284C24.9581 48.8942 28.3919 48.8942 31.0207 48.6521C33.6525 48.4098 35.5604 47.9197 36.9881 46.8786C39.3989 45.1207 40.9527 42.4191 41.264 39.4458C41.4484 37.6854 40.9177 35.7829 39.8111 33.3745C38.7056 30.9687 36.9888 27.9841 34.7237 24.0466L34.7097 24.0222L34.6956 23.9978C32.4307 20.0603 30.7138 17.0758 29.1907 14.912C27.666 12.746 26.2894 11.3329 24.6772 10.6125C21.9546 9.39586 18.8454 9.39586 16.1228 10.6125Z",
    stroke: "url(#paint1_linear_13_1698)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13_1698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3998 18.7435C21.2295 18.7435 21.902 19.4185 21.902 20.2511V32.3125C21.902 33.1451 21.2295 33.8201 20.3998 33.8201C19.5702 33.8201 18.8977 33.1451 18.8977 32.3125V20.2511C18.8977 19.4185 19.5702 18.7435 20.3998 18.7435ZM20.3998 40.3533C21.506 40.3533 22.4027 39.4533 22.4027 38.3431C22.4027 37.2329 21.506 36.3329 20.3998 36.3329C19.2937 36.3329 18.397 37.2329 18.397 38.3431C18.397 39.4533 19.2937 40.3533 20.3998 40.3533Z",
    fill: "url(#paint2_linear_13_1698)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_13_1698",
    x: -25,
    y: -14.8,
    width: 90.7999,
    height: 88.1942,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13_1698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13_1698",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_1698",
    x: 15.1411,
    y: 15.4876,
    width: 17.0291,
    height: 34.6332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.25583,
    dy: 3.25583
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25583
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_1698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_1698",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_1698",
    x1: 33.5999,
    y1: 0,
    x2: 33.5999,
    y2: 28.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E21E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF26A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_1698",
    x1: 0,
    y1: 10.2,
    x2: 38.133,
    y2: 50.8934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_1698",
    x1: 20.4336,
    y1: 44.9572,
    x2: 30.928,
    y2: 43.0503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_1698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_1698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/danger-icon.1dc00f0f352edf113c09fafbb08f7b61.svg";
export { ForwardRef as ReactComponent };